<template>
  <div>
    <form @submit.prevent="submitForm">
      <div class="row g-3">
        <div v-if="!inCourse" class="col-md-12">
          <div class="form-group">
            <label for="">{{ $t('network.networkForm.profileURL') }}</label>
            <input id="presenter_profile_url" v-model="presenterForm.external_url" data-test="presenter_profile_url" type="text" :placeholder="$t('network.networkForm.url')" class="form-control" />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="">{{ $t('network.networkForm.bioSketch') }}</label>
            <Editor
              v-model="presenterForm.short_bio"
              :api-key="tinyMceApiKey"
              :init="{
                height: 300,
                menubar: false,
                automatic_uploads: true,
                browser_spellcheck: true,
                paste_as_text: true,
                relative_urls : false,
                remove_script_host : false,
                plugins: [
                  'advlist autolink lists link charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help',
              }"
            />
          </div>
        </div>
        <div v-if="presenterForm.user_id == null" class="col-md-12">
          <div class="form-group">
            <label for="">{{ $t('network.auth.fullName') }}</label>
            <input id="presenter_text" v-model="presenterForm.text" data-test="presenter_text" type="text" class="form-control" />
          </div>
          <small style="color: rgb(128 128 135);">
            {{ $t('network.presenter.enter-the-full-name-of-the-presenter-in-this-field-it-is-used-in-case-the-presenter-does-not-have-a-full-profile-record-with-resonance') }} </small>
        </div>
        <div v-if="!inCourse" class="col-md-12">
          <h5>{{ $t('network.networkForm.appointments') }}</h5>
        </div>
      </div>
      <div v-if="!inCourse" class="mt-2">
        <div v-for="(appointment, index) in presenterForm.appointments" :key="index">
          <div class="row">
            <b-form-group :label="$t('network.networkForm.title')" class="col">
              <b-form-input id="title" v-model="appointment.title" data-test="title" type="text" :placeholder="$t('network.networkForm.title')"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('network.networkForm.department')" class="col">
              <b-form-input id="department" v-model="appointment.department" data-test="department" type="text" :placeholder="$t('network.networkForm.department')"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('network.networkForm.institutionName')" class="col">
              <b-form-input
                id="institution_name"
                v-model="appointment.institution_name"
                data-test="institution_name"
                type="text"
                :placeholder="$t('network.networkForm.institutionName')"
              ></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('network.networkForm.institutionLoc')" class="col">
              <b-form-input
                id="institution_location"
                v-model="appointment.institution_location"
                data-test="institution_location"
                type="text"
                :placeholder="$t('network.networkForm.institutionLoc')"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="row mb-3">
            <div class="col-3">
              <b-form-checkbox id="is_primary" v-model="appointment.is_primary" data-test="is_primary" @change="setPrimary(index)">{{ $t('PresenterForm.is-primary') }}</b-form-checkbox>
            </div>
            <div class="col">
              <span
                v-if="index + 1 == presenterForm.appointments.length"
                role="button"
                class="badge bg-info me-4"
                @click="presenterForm.appointments.push(getAppointment())"
              >
                {{ $t('network.networkForm.addAnotherAppointment') }}
              </span>
              <span v-if="index != 0" role="button" class="badge bg-danger" @click="deleteRow(index)">
                {{ $t('network.networkForm.removeAppointment') }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div>
          <button id="save" data-test="save" type="submit" class="btn btn-sm btn-primary mt-4"
          style="padding: 0.425rem 1.7rem !important;">
            {{ $t('network.user.save') }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';

export default {
  components: {
    Editor,
  },
  props: {
    form: {
      type: Object,
      default: null,
    },
    inCourse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tinyMceApiKey: process.env.VUE_APP_TINYMCE_API_KEY,
      presenterForm: {},
    };
  },
  mounted() {
    if (!this.form) {
      this.presenterForm = this.getPresenter();
    } else {
      this.presenterForm = this.form;
      if (!this.presenterForm.appointments || this.presenterForm.appointments.length == 0) {
        this.presenterForm.appointments = [this.getAppointment()];
      }
    }
  },
  methods: {
    getPresenter() {
      let appointment = this.getAppointment();
      appointment.is_primary = true;
      let result = {
        external_url: '',
        short_bio: '',
        text: '',
        appointments: [appointment],
      };
      return result;
    },
    getAppointment() {
      return {
        title: '',
        department: '',
        institution_name: '',
        institution_location: '',
        is_primary: false,
      };
    },
    deleteRow(index) {
      if (this.presenterForm.appointments[index].is_primary) this.presenterForm.appointments[0].is_primary = true;
      this.presenterForm.appointments.splice(index, 1);
    },
    setPrimary(index) {
      this.presenterForm.appointments.forEach((appointment, id) => {
        this.presenterForm.appointments[id].is_primary = false;
      });

      this.presenterForm.appointments[index].is_primary = true;
    },
    setupFormData() {
      var formData = new FormData();
      for (let key in this.presenterForm) {
        if (key == 'appointments' || key == 'presenterUser') {
          formData.append(key, JSON.stringify(this.presenterForm[key]));
        } else if (this.presenterForm[key] != null && this.presenterForm[key] !== undefined) {
          formData.append(key, this.presenterForm[key]);
        }
      }
      return formData;
    },
    submitForm() {
      let formData = this.setupFormData();
      let url = 'presenters/update-profile';
      this.$http
        .post(url, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(resp => {
          let data = resp.data.data;
          if (data.user_id !== this.$auth.user.user_id) {
            this.$emit('presenter-invitation-update', data);
          } else {
            this.$store.dispatch('resetUserInfo', resp.data.data);
          }
        });
    },
  },
};
</script>
